import "./bootstrap";
import "../css/app.css";
import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import ErrorBoundary from "./Components/ErrorBoundary";
import { router } from "@inertiajs/react";

const appName = "Patty Cariño";

// Scroll al top en cada navegación de Inertia
router.on("navigate", () => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
});

createInertiaApp({
    title: (title) => appName,
    resolve: (name) =>
        resolvePageComponent(
            `./Paginas/${name}.tsx`,
            import.meta.glob("./Paginas/**/*.tsx")
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <ErrorBoundary>
                <App {...props} />
            </ErrorBoundary>
        );
    },
    progress: {
        color: "#790546",
    },
});
